import tw from 'tailwind-styled-components';
import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  .Overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.85);
    z-Index: 55;
    display: flex;
    align-items: center;
  }
  .content {
    top: 50%;
    left: 50%;
    right: auto;
    bottom: auto;
    margin-Right: -50%;
    background-color: transparent;
    border: 0;
    padding: 0 0 10%;
    text-align: center;
    inset: 55% auto auto 50%;
  }

  @media (max-width: 767px) {
    body.video-modal-open {
      overflow: hidden;
    }

    .video-modal--mobile-large {
      display: flex;
      flex-direction: column;
      width: 95vw;
      width: 95dvw;
      height: 95vh;
      height: 95dvh;
      margin: 0 auto;
      transform: none;
      translate: none;
      padding: calc(12px + env(safe-area-inset-top)) 12px
        calc(12px + env(safe-area-inset-bottom));
      overflow: auto;
      background-color: #000;
    }

    .video-modal--mobile-large .modal-main {
      flex: 1 1 0;
      min-height: 200px;
      height: auto;
      background-color: #000;
      border-radius: 0;
    }

    .video-modal--mobile-large .uc-embedding-container {
      width: 100%;
      min-height: 0;
      max-height: 100%;
    }

    .video-modal--mobile-large .uc-embedding-wrapper {
      justify-content: flex-start;
    }
  }
`;

export const ModelContainer = styled.div``;
ModelContainer.displayName = 'ModelContainer';

export const Close = styled.button`
  svg {
    height: 31px;
    width: 31px;
  }
`;
Close.displayName = 'Close';

export const CloseBtn = tw.span`
    mx-auto
    inline-block
    cursor-pointer
`;
CloseBtn.displayName = 'CloseBtn';

export const TitleWrapper = styled.div`
  padding-bottom: 15px;
`;
TitleWrapper.displayName = 'TitleWrapper';
